import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SolutionDetail from "@/pages/SolutionDetail";

export const Route = createFileRoute("/es/industrias/diagnostico-complementario")({
  head: () => buildRouteHead("/es/industrias/diagnostico-complementario"),
  component: SolutionDetail,
});

